import React from 'react';

export default function Add({fill, className}) {
  return (
    <svg viewBox='0 0 24 24' className={ className ? className : "w-5"}>
      <path  fill={ fill ? fill : '#112233'} id="a" d="M14.084 10.816h6.045c.481 0 .871.367.871.82v1.167c0 .453-.39.82-.87.82h-6.046v6.559c0 .451-.39.818-.871.818h-1.427c-.482 0-.871-.367-.871-.818v-6.559H4.869c-.48 0-.869-.367-.869-.82v-1.167c0-.453.388-.82.87-.82h6.045V4.818c0-.451.39-.818.87-.818h1.428c.481 0 .87.367.87.818v5.998z"/>,
    </svg>
  )
}